import { collection, getDocs, query, orderBy, addDoc, doc, getDoc } from 'firebase/firestore';
import { db } from './config';

/**
 * Fetch all services ordered by priority
 */
export const getServices = async () => {
    try {
        const q = query(collection(db, 'services'), orderBy('order'));
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Error fetching services:', error);
        throw error;
    }
};

/**
 * Fetch all client logos ordered by priority
 */
export const getClients = async () => {
    try {
        const q = query(collection(db, 'clients'), orderBy('order'));
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Error fetching clients:', error);
        throw error;
    }
};

/**
 * Fetch company about information
 */
export const getAboutInfo = async () => {
    try {
        const docRef = doc(db, 'about', 'company');
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return { id: docSnap.id, ...docSnap.data() };
        } else {
            console.warn('About document not found');
            return null;
        }
    } catch (error) {
        console.error('Error fetching about info:', error);
        throw error;
    }
};

/**
 * Fetch contact information
 */
export const getContactInfo = async () => {
    try {
        const docRef = doc(db, 'contact', 'info');
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return { id: docSnap.id, ...docSnap.data() };
        } else {
            console.warn('Contact document not found');
            return null;
        }
    } catch (error) {
        console.error('Error fetching contact info:', error);
        throw error;
    }
};

/**
 * Fetch hero section content
 */
export const getHeroContent = async () => {
    try {
        const docRef = doc(db, 'siteContent', 'hero');
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return { id: docSnap.id, ...docSnap.data() };
        } else {
            console.warn('Hero content not found');
            return null;
        }
    } catch (error) {
        console.error('Error fetching hero content:', error);
        throw error;
    }
};

/**
 * Submit contact form inquiry
 */
export const submitInquiry = async (inquiryData) => {
    try {
        const docRef = await addDoc(collection(db, 'inquiries'), {
            ...inquiryData,
            createdAt: new Date().toISOString(),
            status: 'new'
        });
        return { success: true, id: docRef.id };
    } catch (error) {
        console.error('Error submitting inquiry:', error);
        throw error;
    }
};
